import { MultiplayerRoomCapability } from '@doxyme/extensions-bridge';
import { useAppSelector } from '../../useReduxToolkit';
import { getNonOfflineMembers } from '../../../features/realtime/realtime.selectors';
import { useExtensionsMultiplayer } from './useExtensionsMultiplayer';

export function useExtensionsMultiplayerRoom(): void {
  const members = useAppSelector(getNonOfflineMembers);

  useExtensionsMultiplayer(MultiplayerRoomCapability, members);
}
